// extracted by mini-css-extract-plugin
module.exports = {"fab":"_21LWn","fab-img":"Ha7LF","wrapper":"_3el0r","btn":"_p0NJ","headline":"_1m8Po","content":"sOvKI","button":"iaG5t","image":"_39hKF","modal-content":"_20cF5"};